import React from 'react';
import { Nav, Footer, DisclaimerBar } from '../components/Chrome';
import { useI18n } from '../i18n';

const CONTENT = {
  en: {
    title: 'Privacy Policy',
    updated: 'Effective: January 2026',
    sections: [
      ['1. Data We Collect',
        'When you submit a lead, intake, or contact form, we collect: name, email, phone (optional), company (optional), role, message content, and any property details you provide. We also store reCAPTCHA verification score, request timestamp, and originating source label. We do not knowingly collect data from persons under 18.'],
      ['2. How We Use It',
        'To (a) deliver requested reports, (b) send transactional emails via Resend, (c) process payments via Stripe, (d) prevent abuse via Google reCAPTCHA v3, (e) maintain a pilot ledger for our internal quality tracking, and (f) improve report methodology.'],
      ['3. Third-Party Processors',
        'Payments — Stripe, Inc. Emails — Resend / AWS. Anti-abuse — Google reCAPTCHA. Model inference — Anthropic (Claude) via Emergent. Hosting — Google Cloud. Each processor has its own privacy policy.'],
      ['4. Data Retention',
        'Lead and intake records are retained for 24 months for follow-up. Report data is retained indefinitely unless deletion is requested. Payment records are retained per applicable US tax law.'],
      ['5. Your Rights',
        'You may request access, correction, or deletion of your personal data by emailing ceo@pheigroup.com. We will respond within 30 days.'],
      ['6. Cookies',
        'We use only functional cookies (session, language preference, admin auth token). We do not run advertising or cross-site tracking cookies.'],
      ['7. Security',
        'Data is transmitted over TLS. Admin console is protected by token. Backups are encrypted at rest. No system is perfectly secure; report incidents to ceo@pheigroup.com.'],
      ['8. Changes',
        'We may update this policy. Material changes will be announced via banner or email to active users.'],
      ['9. Contact',
        'Data controller: PHEI Group — ceo@pheigroup.com — www.pheigroup.com.'],
    ],
  },
  es: {
    title: 'Política de Privacidad',
    updated: 'Vigente: enero 2026',
    sections: [
      ['1. Datos que Recopilamos',
        'Cuando envías un lead, intake o formulario de contacto, recopilamos: nombre, email, teléfono (opcional), empresa (opcional), rol, contenido del mensaje y detalles de propiedad que proporciones. También almacenamos score de verificación reCAPTCHA, timestamp y etiqueta de origen. No recopilamos deliberadamente datos de menores de 18 años.'],
      ['2. Cómo Los Usamos',
        'Para (a) entregar los reportes solicitados, (b) enviar emails transaccionales vía Resend, (c) procesar pagos vía Stripe, (d) prevenir abuso vía Google reCAPTCHA v3, (e) mantener un pilot ledger interno de calidad, y (f) mejorar la metodología de reportes.'],
      ['3. Procesadores Terceros',
        'Pagos — Stripe, Inc. Emails — Resend / AWS. Anti-abuso — Google reCAPTCHA. Inferencia del modelo — Anthropic (Claude) vía Emergent. Hosting — Google Cloud. Cada procesador tiene su propia política de privacidad.'],
      ['4. Retención',
        'Registros de lead e intake se retienen por 24 meses para seguimiento. Los datos de reportes se retienen indefinidamente salvo solicitud de eliminación. Registros de pago se retienen según ley fiscal aplicable de EE. UU.'],
      ['5. Tus Derechos',
        'Puedes solicitar acceso, corrección o eliminación de tus datos personales escribiendo a ceo@pheigroup.com. Responderemos en 30 días.'],
      ['6. Cookies',
        'Usamos solo cookies funcionales (sesión, preferencia de idioma, token de admin). No usamos cookies de publicidad ni tracking cross-site.'],
      ['7. Seguridad',
        'Los datos se transmiten sobre TLS. La consola admin está protegida por token. Los backups se encriptan en reposo. Ningún sistema es perfectamente seguro; reporta incidentes a ceo@pheigroup.com.'],
      ['8. Cambios',
        'Podemos actualizar esta política. Cambios materiales se anunciarán por banner o email a usuarios activos.'],
      ['9. Contacto',
        'Responsable de datos: PHEI Group — ceo@pheigroup.com — www.pheigroup.com.'],
    ],
  },
};

export default function Privacy() {
  const { lang } = useI18n();
  const c = CONTENT[lang] || CONTENT.en;
  return (
    <div>
      <Nav />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16">
        <div className="mono text-[10px] uppercase tracking-widest2 text-gold mb-4">LEGAL</div>
        <h1 className="serif text-5xl">{c.title}</h1>
        <div className="mono text-[10px] uppercase tracking-widest2 text-white/40 mt-2">{c.updated}</div>
        <div className="mt-10 space-y-8">
          {c.sections.map(([h, b], i) => (
            <div key={i}>
              <h2 className="serif text-xl text-gold">{h}</h2>
              <p className="mt-2 text-white/75 leading-relaxed">{b}</p>
            </div>
          ))}
        </div>
      </div>
      <DisclaimerBar />
      <Footer />
    </div>
  );
}
